import axios from 'axios';
import { message } from 'antd';

import {
  FETCH_TRAINER_REFLECTION_SURVEY_SUCCESS,
  FETCH_TRAINER_REFLECTION_SURVEY_FAIL,
  TRAINER_REFLECTION_EXISTS,
  SUBMIT_TRAINER_REFLECTION_START,
  SUBMIT_TRAINER_REFLECTION_SUCCESS,
  SUBMIT_TRAINER_REFLECTION_FAIL,
  RESET_TRAINER_REFLECTION
} from '../constants/actionTypes';

const DEFAULT_FETCH_ERROR =
  'Could not load the feedback form. Please try again.';

export const resetTrainerReflection = () => dispatch =>
  dispatch({ type: RESET_TRAINER_REFLECTION });

export const fetchTrainerReflectionSurvey = shortId => dispatch =>
  axios
    .get(`/api/survey/${shortId}/trainer-reflection`)
    .then(res =>
      dispatch({
        type: FETCH_TRAINER_REFLECTION_SURVEY_SUCCESS,
        payload: res.data
      })
    )
    .catch(() => {
      message.error(DEFAULT_FETCH_ERROR);
      dispatch({ type: FETCH_TRAINER_REFLECTION_SURVEY_FAIL });
    });

export const checkTrainerReflectionExists = sessionId => dispatch =>
  axios
    .get(`/api/sessions/${sessionId}/trainer-reflection`)
    .then(res => {
      if (res.data && res.data.response) {
        dispatch({
          type: TRAINER_REFLECTION_EXISTS,
          payload: res.data.response
        });
        return true;
      }
      return false;
    })
    .catch(() => false);

export const submitTrainerReflection = ({
  sessionId,
  formState
}) => dispatch => {
  dispatch({
    type: SUBMIT_TRAINER_REFLECTION_START,
    payload: { sessionId }
  });

  return axios
    .post(`/api/sessions/${sessionId}/trainer-reflection`, {
      formState
    })
    .then(() =>
      dispatch({
        type: SUBMIT_TRAINER_REFLECTION_SUCCESS,
        payload: { sessionId }
      })
    )
    .catch(err => {
      const response = err && err.response;
      dispatch({
        type: SUBMIT_TRAINER_REFLECTION_FAIL,
        payload: {
          sessionId,
          status: response && response.status,
          message: response && response.data && response.data.error
        }
      });
    });
};
